<template>
    <div class="grid-header">
        <div class="grid-title">
            <h1>Focus events by user</h1>
        </div>
    </div>
    <div class="grid-content">
        <div style="width: 100%; flex: 1 1 auto;">
            <ag-grid-vue
                class="ag-theme-alpine grid"
                style="width: 100%; flex: 1 1 auto;"
                :column-defs="focusByTeamColumnDefinitions"
                :default-col-def="defaultColDef"
                :row-data="data"
                :on-grid-ready="onGridReady"
                :grid-options="gridOptions"
                group-display-type="custom"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { AgGridVue } from 'ag-grid-vue3';
import { focusByTeamColumnDefinitions } from '../utils/focusColumnDefinitions';
import { ref, defineProps } from 'vue';
import { AgGridEvent } from 'ag-grid-community';
type FocusEventsByUserProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any[];
}
defineProps<FocusEventsByUserProps>();

const defaultColDef =   {
    resizable: true,
    filter: true,
    flex: 1,
    sortable: true,
    minWidth: 100,
    cellStyle: { 'text-align:': 'left' }
};
const gridApi = ref();
const gridColumnApi = ref();
const gridOptions = {
    suppressAggFuncInHeader: true,
    autoSizeStrategy: { type: 'fitCellContents' },
    autoGroupColumnDef: { headerName: 'Teams' }
};

const onGridReady = (evt: AgGridEvent) => {
    gridApi.value = evt.api;
    gridColumnApi.value = evt.columnApi;
    gridColumnApi.value.autoSizeColumns();
};
</script>
<style lang="scss">
.grid {
  width: 100%;
  height: 100%;
  min-height: 250px;
  margin-inline: auto;
}
.grid-header {
  display: flex;
  flex-direction: row;
  align-items: center;

  .grid-title {
    margin-left: 16px;
  }
}
.grid-content {
  padding: 1.5rem;
}
</style>